import { render, staticRenderFns } from "./VideoUpload.vue?vue&type=template&id=4a00473b&scoped=true"
import script from "./VideoUpload.vue?vue&type=script&lang=js"
export * from "./VideoUpload.vue?vue&type=script&lang=js"
import style0 from "./VideoUpload.vue?vue&type=style&index=0&id=4a00473b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a00473b",
  null
  
)

export default component.exports